export default __webpack_public_path__ + "static/media/PEGI_12.af3cf820.svg";